<template>
<div class="chapter">
<div class="inner_page">
<div id="V4039_ebook-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN" id="toc_marker-4"><span class="char-style-override-5">HARBOR<br/>NOCTURNE</span></p>
<p class="BTSpace para-style-override-2"><span class="char-style-override-6">Joseph Wambaugh</span></p>
<p class="BTSpace para-style-override-4"><span class="char-style-override-6"><img alt="mplogo_edited.jpg" class="image" height="46" src="images/mplogo_edited_fmt.jpeg" width="49"/></span></p>
<p class="BT1stPara para-style-override-5"><span class="char-style-override-7">Mysterious Press</span></p>
<p class="BT1stPara para-style-override-2"><span class="char-style-override-8">an imprint of Grove/Atlantic, Inc.</span></p>
<p class="BT1stPara para-style-override-2"><span class="char-style-override-7">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4039_ebook3.vue?7ddc17a7